export const Home = () => {
    return (
        <div>Welcome</div>
    )
}